import React from 'react';

interface MetricCardProps {
  title: string;
  value: string | number;
  change?: {
    value: number;
    type: 'increase' | 'decrease';
  };
  icon?: React.ReactNode;
  color?: 'blue' | 'green' | 'yellow' | 'red' | 'purple';
}

const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  change,
  icon,
  color = 'blue'
}) => {
  const colorClasses = {
    blue: 'bg-blue-50 text-blue-600 border-blue-200',
    green: 'bg-green-50 text-green-600 border-green-200',
    yellow: 'bg-yellow-50 text-yellow-600 border-yellow-200',
    red: 'bg-red-50 text-red-600 border-red-200',
    purple: 'bg-purple-50 text-purple-600 border-purple-200'
  };

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4 md:p-5 hover:shadow-md transition-shadow">
      <div className="flex items-center gap-3">
        {icon && (
          <div className={`p-2.5 md:p-3 rounded-xl border ${colorClasses[color]} flex-shrink-0`}>
            {icon}
          </div>
        )}
        <div className="min-w-0 flex-1">
          <p className="text-xs md:text-sm font-medium text-gray-500 truncate">{title}</p>
          <div className="flex items-center gap-2 mt-0.5">
            <p className="text-lg md:text-2xl font-bold text-gray-900 truncate">{value}</p>
            {change && (
              <span
                className={`text-xs md:text-sm font-medium flex-shrink-0 ${
                  change.type === 'increase' ? 'text-green-600' : 'text-red-600'
                }`}
              >
                {change.type === 'increase' ? '↗' : '↘'} {Math.abs(change.value)}%
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetricCard;